import { Phone, Navigation, MapPin, Clock } from "lucide-react";
import { BUSINESS } from "../data/business";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const MapSection = ({ dark = false }) => (
  <section className={dark ? "bg-ink" : "bg-ivory"} data-testid="location-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
      <SectionHeading
        dark={dark}
        eyebrow="Visit Us"
        title="Find New Lookz"
        text="In the heart of New Bakaram, Gandhi Nagar — easy to reach, easy to find."
      />
      <div className="mt-10 grid gap-6 lg:grid-cols-5 items-stretch">
        <Reveal className="lg:col-span-2">
          <div className={`h-full rounded-xl border p-7 flex flex-col ${dark ? "bg-coal border-white/10" : "bg-paper border-ink/10 shadow-[0_14px_40px_-22px_rgba(17,17,17,0.3)]"}`}>
            <h3 className={`font-display font-bold text-xl flex items-center gap-2 ${dark ? "text-white" : "text-ink"}`}>
              <MapPin size={18} className="text-copper" aria-hidden="true" /> Address
            </h3>
            <address className={`not-italic mt-3 text-sm leading-relaxed ${dark ? "text-white/60" : "text-mute"}`} data-testid="location-address">
              {BUSINESS.addressLines.map((l) => <span key={l} className="block">{l}</span>)}
            </address>
            <a href={BUSINESS.phoneHref} data-testid="location-phone" className={`mt-5 flex items-center gap-2 font-display font-bold ${dark ? "text-white" : "text-ink"} hover:text-copper transition-colors`}>
              <Phone size={16} className="text-copper" aria-hidden="true" /> {BUSINESS.phoneDisplay}
            </a>
            <p className={`mt-5 flex items-start gap-2 text-sm ${dark ? "text-white/50" : "text-mute"}`} data-testid="location-hours">
              <Clock size={15} className="text-copper mt-0.5 shrink-0" aria-hidden="true" />
              {BUSINESS.hours.length
                ? BUSINESS.hours.map((h) => `${h.days}: ${h.time}`).join(" · ")
                : BUSINESS.hoursNote}
            </p>
            <div className="mt-auto pt-7 flex flex-col sm:flex-row gap-3">
              <a href={BUSINESS.phoneHref} data-testid="location-call-btn" className="flex-1 rounded-full bg-copper text-ink text-center font-display font-bold text-sm px-5 py-3 transition-colors hover:bg-copper-hover">
                Call Now
              </a>
              <a href={BUSINESS.directionsUrl} target="_blank" rel="noopener noreferrer" data-testid="location-directions-btn" className={`flex-1 rounded-full border text-center font-display font-semibold text-sm px-5 py-3 inline-flex items-center justify-center gap-2 transition-colors ${dark ? "border-white/20 text-white hover:border-copper hover:text-copper" : "border-ink/20 text-ink hover:border-copper hover:text-copper"}`}>
                <Navigation size={15} aria-hidden="true" /> Get Directions
              </a>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-3">
          <div className={`h-full min-h-[340px] rounded-xl overflow-hidden border ${dark ? "border-white/10" : "border-ink/10"}`}>
            <iframe
              src={BUSINESS.mapsEmbedUrl}
              title="Map — New Lookz Hair Salon, Gandhi Nagar, Hyderabad"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              className="w-full h-full min-h-[340px] grayscale-[35%] contrast-[1.05]"
              data-testid="google-map-embed"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
